import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DayPicker from 'react-day-picker';
import MomentLocaleUtils from 'react-day-picker/moment';
import { injectIntl, intlShape } from 'react-intl';
import moment from 'moment';
import isEmpty from "lodash/isEmpty";
import reduce from "lodash/reduce";
import { Spinner } from '../../../../decorators/spinner';
import { ArrowForward, ArrowForwardDisabled } from '../../../../icons';

const CustomHeader = (props) => {
  const {
    nextMonth,
    showPreviousButton,
    onPreviousClick,
    onNextClick
  } = props;

  const handleNextMonthClick = (e) => {
    e.preventDefault();
    if (nextMonth) {
      onNextClick();
    }
  };

  const handlePrevMonthClick = (e) => {
    e.preventDefault();
    if (showPreviousButton) {
      onPreviousClick();
    }
  };

  return (
    <div className="day_picker_nav_wrap flex middle absolute">
      <button
        className="btn-clear flex middle center"
        onClick={handlePrevMonthClick}
      >
        {!showPreviousButton
          ? <ArrowForwardDisabled className="h4" />
          : <ArrowForward className="h4" />
        }
      </button>
      <button
        className="btn-clear flex middle center"
        onClick={handleNextMonthClick}
      >
        <ArrowForward className="h4" />
      </button>
    </div>
  );
};

const DatePicker = ({
  value,
  setValue,
  intl,
  getMonthAvailability,
  monthAvailability,
  monthAvailabilityLoading
}) => {
  const [currentMonth, setCurrentMonth] = useState(value || new Date());

  const handleMonthChange = (date) => {
    setCurrentMonth(date);
  };

  useEffect(() => {
    if (currentMonth) {
      getMonthAvailability(currentMonth);
    }
  }, [currentMonth]);

  const sortAvailability = useCallback((bookedType) => {
    if (isEmpty(monthAvailability)) return [];

    return reduce(monthAvailability, (result, dayHash, day) => {
      if (dayHash[bookedType]) {
        const { year, month } = dayHash;
        result.push(new Date(year, month - 1, day));
      }
      return result;
    }, []);
  }, [monthAvailability]);

  const handleDayClick = (date, modifiers) => {
    if (modifiers.disabled) { return; }
    setValue(date);
  };

  if (monthAvailabilityLoading) {
    return (
      <div className="spinner-container">
        <Spinner />
      </div>
    );
  }

  const isDayOfMonth = moment(value).get('month') === moment(currentMonth).get('month');

  return (
    <DayPicker
      mode='single'
      locale={intl.locale || 'en-US'}
      month={currentMonth}
      onMonthChange={handleMonthChange}
      onDayClick={handleDayClick}
      className="mobile-day-picker-tray"
      fromMonth={new Date()}
      localeUtils={MomentLocaleUtils}
      selectedDays={isDayOfMonth ? value : null}
      navbarElement={(props) => CustomHeader({ ...props })}
      modifiers={{
        disabled: [{ before: new Date() }, ...sortAvailability('is_fully_booked')]
      }}
      modifiersClassNames={{
        selected: 'date_picker_selected_day',
        today: 'date_picker_today'
      }}
    />
  );
};

DatePicker.propTypes = {
  value: PropTypes.instanceOf(Date),
  setValue: PropTypes.func,
  getMonthAvailability: PropTypes.func,
  monthAvailability: PropTypes.array,
  monthAvailabilityLoading: PropTypes.bool,
  intl: intlShape
};

CustomHeader.propTypes = {
  nextMonth: PropTypes.instanceOf(Date),
  showPreviousButton: PropTypes.bool,
  onPreviousClick: PropTypes.func,
  onNextClick: PropTypes.func
};

exports.DatePicker = injectIntl(DatePicker);
